// import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import styled from 'styled-components'
// import useSWR from 'swr'
import React, { useContext, useEffect, useState } from 'react'
import { getLanguage, requestTranslation } from '@futures-platform/i18n'
// import {
//   Modal, // paddingModalStyles,
// } from '@futures-platform/ui'
import tagIcon from '../../icons/tag.svg'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import Actors from '../Actors/index'
import CardBody from '../CardBody'
import CardFooter from '../CardFooter'
import CardHeader from '../CardHeader'
import DevelopmentPath from '../DevelopmentPath'
import Drivers from '../Drivers'
import History from '../History/index'
import MainActors from '../MainActors'
import RelatedPhenomena from '../RelatedPhenomena/index'
import RelatedScenarios from '../RelatedScenarios'
import YoutubeImageEmbed from '../YoutubeImageEmbed'
import { PhenomenaTagList } from './PhenomenaTagList'
import { DropdownValue } from './index'

//open by sid or create new from drivers, e.g. [1, -1]
const Review = ({
  data,
  gid,
  InfoModalClose,
  relatedPhenomena,
  relatedScenarios: relatedScenariosProp,
  historyDataState,
}) => {
  const [iconVerbalDrivers, seticonVerbalDrivers] = useState('expand_more')
  const [iconNewsFeedSection, seticonNewsFeedSection] = useState('expand_more')

  const handleChangeIconNewsFeedSection = () => {
    if (iconNewsFeedSection === 'expand_more')
      seticonNewsFeedSection(() => `expand_less`)
    else {
      seticonNewsFeedSection(() => `expand_more`)
    }
  }
  const handleChangeiconVerbalDrivers = () => {
    if (iconVerbalDrivers === 'expand_more')
      seticonVerbalDrivers(() => `expand_less`)
    else {
      seticonVerbalDrivers(() => `expand_more`)
    }
  }
  const {
    dispatch,
    state: {
      scenarioSet,
      scenario,
      devPaths,
      tags,
      isMainActorsDeactivated,
      isRelatedScenariosDeactivated,
      isTagsDeactivated,
      relatedScenarios,
    },
  } = useContext(DataContext)
  //init with this when creating new scenario

  return (
    <div>
      {!!scenario && (
        <div
          className="container p_4"
          style={{
            background: '#fff',
            color: '#333',
            paddingLeft: '5%',
            paddingRight: '5%',
            paddingTop: '1rem',
            minWidth: 'unset',
          }}>
          <CardHeader scenario={scenario} />
          {Number(gid) !== 0 && (
            <div
              className="modal-form-section"
              style={{
                padding: 0,
              }}>
              <div className="form-group">
                {/* <h4
                      style={{
                        fontFamily: 'L10',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: '18px',
                        letterSpacing: '0.0714286px',
                      }}>
                      Instructions
                    </h4> */}
                <>
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseVerbalDrivers"
                    aria-expanded="true"
                    onClick={handleChangeiconVerbalDrivers}
                    style={{ cursor: 'pointer' }}>
                    <h3
                      style={{
                        fontFamily: 'L10',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: '18px',
                        letterSpacing: '0.0714286px',
                      }}>
                      Instructions
                    </h3>
                    <div>
                      <i className="material-icons">{iconVerbalDrivers}</i>
                    </div>
                  </Dropdown>
                  <div id="collapseVerbalDrivers" className=" show">
                    <div className="form-group">
                      {/* <h4>Development Path</h4> */}
                      <div
                        className="d-flex flex-column"
                        style={{
                          fontfamily: 'L10',
                          fontStyle: 'normal',
                          fontweight: 500,
                          fontSize: '13px',
                          lineHeight: '20px',
                        }}>
                        <li>
                          Fill in the following fields:{' '}
                          <strong>
                            {data?.scenarioSet?.instructions?.fieldInstructions}
                          </strong>
                        </li>
                        <li>
                          Length of the narrative:{' '}
                          <strong>
                            {data?.scenarioSet?.instructions?.lengthNarrative}
                          </strong>
                        </li>
                        <li>
                          Number of the paragraphs:{' '}
                          <strong>
                            {
                              data?.scenarioSet?.instructions
                                ?.numberOfParagraphs
                            }
                          </strong>
                        </li>
                        <li>
                          Perspectives:{' '}
                          <strong>
                            {data?.scenarioSet?.instructions?.perspectives}
                          </strong>
                        </li>
                        <li>
                          Writings style:{' '}
                          <strong>
                            {!!data?.scenarioSet?.instructions?.writingStyles
                              ?.length &&
                              data?.scenarioSet?.instructions?.writingStyles?.map(
                                (wr) => {
                                  if (
                                    wr ===
                                    data?.scenarioSet?.instructions
                                      ?.writingStyles[
                                      data?.scenarioSet?.instructions
                                        ?.writingStyles?.length - 1
                                    ]
                                  ) {
                                    if (!!wr?.includes('harry-marked/')) {
                                      return wr?.substring(13)
                                    } else return wr
                                  } else {
                                    if (!!wr?.includes('harry-marked/')) {
                                      return wr?.substring(13) + ' - '
                                    }
                                    return wr + ' - '
                                  }
                                },
                              )}
                          </strong>
                        </li>
                        <li>
                          Suggested editors:{' '}
                          <strong>
                            {data?.scenarioSet?.instructions?.fieldInstructions}
                          </strong>
                        </li>
                        <li>
                          More info:{' '}
                          <strong>
                            {data?.scenarioSet?.instructions?.instructions}
                          </strong>
                        </li>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          )}
          <YoutubeImageEmbed content={scenario} isReviewMode={true} />
          <Drivers drivers={scenarioSet?.drivers} scenario={scenario} />
          <CardBody card={scenario} />
          <DevelopmentPath developmentPath={devPaths} />

          {true && <Actors gid={gid} scenario={scenario} />}

          {true && (
            <RelatedPhenomena
              className="relatedPhenomena-content-card"
              phenomena={relatedPhenomena}
              gid={gid}

              // lang={langRadar}
            />
          )}
          {!isRelatedScenariosDeactivated && (
            <RelatedScenarios
              relatedScenarios={relatedScenariosProp || relatedScenarios}
              gid={gid}
              scenarioSetId={scenarioSet?.id}
            />
          )}
          <div
            style={{
              background: '#E8DEDB',
              width: '100%',
              height: '1px',
              marginBottom: '30px',
            }}></div>
          {!isTagsDeactivated && (
            <div
              style={{
                display: 'flex',
              }}>
              <img
                style={{
                  marginTop: '5px',
                  marginRight: '12px',
                }}
                src={tagIcon}
              />
              <PhenomenaTagList
                gid={
                  scenarioSet?.groupId ||
                  gid ||
                  data?.scenarioSet?.groupId ||
                  (!!data?.scenarioCard?.groups?.length
                    ? data?.scenarioCard?.groups[0]
                    : 0)
                }
                scenario={{
                  id: scenario.id,
                  tags: Array.from(!!tags?.length ? tags : []),
                }}
                language={getLanguage() || 'en'}
              />
            </div>
          )}
          {/* {true && <History card={scenario} />} */}

          <div
            className="modal-form-section"
            style={{
              marginTop: '21px',
              marginBottom: '21px',
              paddingTop: '16px',
              paddingBottom: '16px',
              marginLeft: 'calc(-5% - 4px)',
              marginRight: 'calc(-5% - 4px)',
              paddingLeft: 'calc( 5% + 4px)',
              paddingRight: 'calc( 5% + 4px)',
              width: 'calc(110% + 8px)',
              backgroundColor: '#f1f3f3',
            }}>
            <Dropdown
              className="dropdown-toggle d-flex align-items-center justify-content-between"
              type="button"
              data-toggle="collapse"
              data-target="#collapsenews"
              aria-expanded="true"
              style={{ cursor: 'pointer' }}
              onClick={handleChangeIconNewsFeedSection}>
              <h3
                className="mb-0"
                style={{
                  fontSize: '18px',
                }}>
                History and change log
                <DropdownValue></DropdownValue>
              </h3>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p
                  style={{
                    margin: 0,
                    marginRight: '24px',
                    fontWeight: '100',
                    fontSize: '13px',
                  }}>
                  {iconNewsFeedSection === 'expand_more'
                    ? requestTranslation('ShowHistory')
                    : requestTranslation('HideHistory')}
                </p>
                <i className="material-icons">{iconNewsFeedSection}</i>
              </div>
            </Dropdown>
            <div id="collapsenews" className="collapse mt-4 show">
              <>
                {!!historyDataState?.length &&
                  historyDataState?.map((history) => {
                    return (
                      <>
                        {!!history?.isShown && (
                          <div
                            style={{
                              marginBottom: '16px',
                              fontSize: '13px',
                            }}>
                            <p
                              style={{
                                margin: 0,
                                color: '#637282',
                                fontSize: '13px',
                              }}>{`${
                              history?.isCreator ? 'Created' : 'Edited'
                            } on ${history?.date} by ${
                              history?.editorName
                            }`}</p>
                            <p
                              style={{
                                margin: 0,
                                fontWeight: 500,
                                fontSize: '13px',
                              }}>
                              {history?.description}
                            </p>
                          </div>
                        )}
                      </>
                    )
                  })}
              </>
            </div>
          </div>

          <CardFooter
            data={data}
            scenarioId={data.scenarioCard?.id}
            lang={getLanguage() || 'en'}
            gid={scenarioSet?.groupId}
            isReviewMode={true}
            InfoModalClose={InfoModalClose}
          />
        </div>
      )}
    </div>
  )
}
export default Review
const Dropdown = styled.div`
  -webkit-appearance: none;
  &:after {
    display: none;
  }
`
